(() => {
  const ROOT_SELECTOR = 'dynamic-dates';
  const ITEM_SELECTOR = '[data-dynamic-date="true"]';

  const locale = () => document.documentElement.lang || 'en';
  const csv = (value) => String(value || '').split(',').map((item) => item.trim()).filter(Boolean);
  const dateKey = (date) => `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  const weekdayKey = (date) => date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

  const nextAllowedDate = (offset, skippedDays, skippedDates) => {
    const date = new Date();
    date.setHours(12, 0, 0, 0);
    let remaining = Math.max(0, Number(offset) || 0);
    let guard = 0;

    while (guard < 370) {
      const skipped = skippedDays.has(weekdayKey(date)) || skippedDates.has(dateKey(date));
      if (!skipped && remaining <= 0) return date;
      if (!skipped) remaining -= 1;
      date.setDate(date.getDate() + 1);
      guard += 1;
    }
    return date;
  };

  const formatDate = (date, format) => {
    const options = {
      day_mm_dd: { weekday: 'long', month: 'long', day: 'numeric' },
      day_dd_mm: { weekday: 'long', day: 'numeric', month: 'long' },
      mm_dd: { month: 'short', day: 'numeric' },
      dd_mm: { day: 'numeric', month: 'long' },
      dd_mm_no_dot: { day: 'numeric', month: 'long' },
      day_dd_mm_numeric: { weekday: 'short', day: '2-digit', month: '2-digit' },
      dd_mm_numeric: { day: '2-digit', month: '2-digit' }
    }[format] || { month: 'short', day: 'numeric' };

    try {
      return new Intl.DateTimeFormat(locale(), options).format(date);
    } catch (_error) {
      return new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' }).format(date);
    }
  };

  const renderRoot = (root) => {
    const skippedDays = new Set(csv(root.dataset.daysToSkip).map((value) => value.toLowerCase()));
    const skippedDates = new Set(csv(root.dataset.datesToSkip));
    const format = root.dataset.dateFormat || 'mm_dd';

    root.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
      const template = item.dataset.text || '';
      const start = nextAllowedDate(item.dataset.minDays, skippedDays, skippedDates);
      const end = nextAllowedDate(item.dataset.maxDays, skippedDays, skippedDates);
      const rendered = template
        .replaceAll('[start_date]', formatDate(start, format))
        .replaceAll('[end_date]', formatDate(end, format));
      if (item.innerHTML !== rendered) item.innerHTML = rendered;
    });
    root.dataset.pdDatesRendered = 'true';
  };

  const renderAll = (scope = document) => {
    if (scope.matches?.(ROOT_SELECTOR)) renderRoot(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(renderRoot);
  };

  let scheduled = false;
  const scheduleRender = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      renderAll();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRender, { once: true });
  } else {
    scheduleRender();
  }
  window.addEventListener('load', scheduleRender, { once: true });

  new MutationObserver((mutations) => {
    if (mutations.some((mutation) =>
      [...mutation.addedNodes].some((node) =>
        node.nodeType === Node.ELEMENT_NODE && (node.matches?.(ROOT_SELECTOR) || node.querySelector?.(ROOT_SELECTOR))
      ) || mutation.target.closest?.(ROOT_SELECTOR)
    )) scheduleRender();
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
